import dayjs from 'dayjs'
import { DATE_FORMAT } from '../constant'

export const getNowDate = (format = DATE_FORMAT) => {
  return dayjs().format(format)
}

/**
 * 处理成类型需要的展示的文件类型
 * @param text 文件类型
 * @returns string
 */
export function getFileType(text?: string) {
  let type = 'file'
  const lowerCaseText = text?.toLowerCase()
  switch (lowerCaseText) {
    case 'ppt':
    case 'pptx':
      type = 'ppt'
      break
    case 'pdf':
      type = 'pdf'
      break
    case 'docx':
    case 'doc':
      type = 'word'
      break
    case 'json':
    case 'txt':
      type = 'text'
      break
    case 'xls':
    case 'xlsx':
      type = 'excel'
      break
    case 'gif':
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'webp':
    case 'tif':
    case 'wmf':
    case 'dib':
      type = 'image'
      break
    case 'mp4':
      type = 'video'
      break
    default:
      type = 'file'
      break
  }

  return type
}
